import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GenerateRecommendations as GenerateRecommendationsMutation,
    GenerateRecommendationsVariables as GenerateRecommendationsMutationVariables,
    RecommendationsGenerateInput,
} from 'nutshell-graphql-types';

import RECOMMENDATIONS_GENERATE from '../mutations/generate-recommendations.graphql';

export const useGenerateRecommendations = (): {
    generateRecommendations: (input: RecommendationsGenerateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [generateRecommendationsMutation, {loading, error}] = useMutation<
        GenerateRecommendationsMutation,
        GenerateRecommendationsMutationVariables
    >(RECOMMENDATIONS_GENERATE);

    return {
        generateRecommendations: (input: RecommendationsGenerateInput) => {
            return generateRecommendationsMutation({
                variables: {input},
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
